import React, { useState, useEffect } from 'react'
import * as components from '../../components'
import { useDispatch } from 'react-redux'
import { VoucherDataGrid } from './VoucherDataGrid'
import * as rest from '../../services'
import { showErrorToast } from '../../state/toasts'
import {Ticket} from "../../api";

interface VouchersPageProps{
     defaultFilters?:Record<string,string|number>
  displayData?:Array<Ticket>
  showOnlyPages?:boolean
  title?:string,
  path?:string,
}
export const VouchersPage = ({  defaultFilters}:VouchersPageProps) => {
  const dispatch = useDispatch()

  const [apiResponse, setAPIResponse] = useState(null)
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState(null)
  const [gridData, setGridData] = useState({})

 const handleTableChange = (type, { page, sizePerPage }) => {
      console.log(type, { page, sizePerPage })
    const paginationFilters = {
      ...gridData,
      page: page,
      page_size: sizePerPage,
    }
    setGridData(paginationFilters)
  }
  const onFilter = (data) => {
    const searchFilters = data ? { ...data, page: 1 } : gridData
    setGridData({ ...searchFilters })
  }

  const getData = (data?) => {
      let finalPayload = {...defaultFilters, ...data,...gridData}
      setAPIResponse(null)
      setLoading(true)
      new rest.VoucherService()
        .makeGetRequest(finalPayload)
        .then((response) => {
          setAPIResponse(response)
        })
        .catch((errors) => {
          dispatch(showErrorToast('Error', 'Could not get tickets list data'))
        }).finally(()=>{
            setLoading(false)
      })
    }

  useEffect(() => {
    getData()
  }, [gridData])
  return loading ? (
    <components.Loading />
  ) : (
    <>
      {errors ? <components.ErrorDisplay error={errors} /> : ''}
      {!errors && apiResponse ? (
        <VoucherDataGrid
          onTableChange={handleTableChange}
          onFilter={onFilter}
          data={apiResponse.results}
          sizePerPage={apiResponse.page_size}
          count={apiResponse.count}
          page={apiResponse.current}
        />
      ) : (
        ''
      )}
    </>
  )
}
